import { getActiveCount, UBO_ACTIVE_FIELDS } from "../mle.utils";
import { UBO_CREATE_FORM_NAME, uboFields } from "./constant";
import React, { useEffect, useState } from "react";

const UboActiveField = ({ actions, item, isViewMode, setActiveCount, index, activeCount, fields }) => {
    const [isToggled, setIsToggled] = useState(activeCount[index] ?? true);

    useEffect(() => {
        
        setActiveCount(prev => {
            prev[index] = isToggled;
            return prev;
        });
    }, [fields.length, isToggled]);

  const handleToggle = () => {
    setIsToggled(!isToggled);
    
    actions.change(UBO_CREATE_FORM_NAME, uboFields.uboActive.name(item), !isToggled ? UBO_ACTIVE_FIELDS.ACTIVE : UBO_ACTIVE_FIELDS.INACTIVE);
  };
    
    return (
        <>
            <div className="form-field-switch">
                <label className="switch">
                    <input
                        type="checkbox"
                        checked={isToggled} 
                        onChange={handleToggle} 
                        disabled={isViewMode || (!isToggled && getActiveCount(activeCount))}
                    />
                    <span className="slider round" />
                </label>
            </div>
        </>
    );
};

export default UboActiveField;
